import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { nextjsPlugin } from "@datadog/browser-rum-nextjs";
import { markDataDogLogsInitialized } from "cy-datadog/client";

datadogRum.init({
  applicationId: "debea1ed-d902-4449-8b47-50c8242dae52",
  clientToken: "pub37368d6b7c04cc7795096a1ae564fd5e",
  site: "us5.datadoghq.com",
  service: "tv-client-website",
  env: process.env.NEXT_PUBLIC_VERCEL_ENV, // e.g. 'prod', 'staging-1', 'dev'
  version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA, // e.g. '1.0.0'
  sessionSampleRate: 100, // capture 100% of sessions
  sessionReplaySampleRate: 20, // capture 20% of sessions with replay
  trackResources: true, // Enable Resource tracking
  trackUserInteractions: true, // Enable Action tracking
  trackLongTasks: true, // Enable Long Tasks tracking
  allowedTracingUrls: [(url) => url.startsWith(window.location.origin)],

  // ----- Recommended Options -----
  // allowedTracingUrls: '<BACKEND_URL>',		// Enable distributed tracing
  // defaultPrivacyLevel: 'mask-user-input',	// 'mask-user-input' | 'allow' | 'mask'
  plugins: [nextjsPlugin()],
});

datadogLogs.init({
  clientToken: "pub37368d6b7c04cc7795096a1ae564fd5e",
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "us5.datadoghq.com",
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  service: "tv-client-website",
  version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  env: process.env.NEXT_PUBLIC_VERCEL_ENV,
});
datadogLogs.logger.setHandler(["console", "http"]);
datadogLogs.logger.setLevel(
  process.env.NODE_ENV === "production" ? "info" : "debug",
);

markDataDogLogsInitialized();
export { onRouterTransitionStart } from "@datadog/browser-rum-nextjs";
